import loadable from 'components/dynamic-import';
import { ErrorPage } from './ErrorPage';
import { FatalError } from './FatalError';
import { UserErrorDialog } from './UserErrorDialog';

const NotFound = loadable(() => import('./NotFound'));

export { FatalError, NotFound, UserErrorDialog };
export default ErrorPage;
